<template>
  <div class="indexPage">
    <!-- 背景图片 -->
    <div class="bigRound"></div>
    <div class="miniRound"></div>
    <div class="arrow"></div>
    <div class="btnBg"></div>
    <div class="centerRoundBig">
      <img src="../../assets/images/indexPage/centerRoundBig.png" alt="" />
    </div>
    <div class="centerRoundMini">
      <img src="../../assets/images/indexPage/centerRoundMini.png" alt="" />
    </div>
    <!-- 标题 -->
    <div class="centerTit font-size-28">
      <div class="tit-item">kehui-green.com</div>
      <!-- <div class="tit-item">管理平台</div> -->
    </div>
    <div class="beian">
      <a class="beianLink" href="https://beian.miit.gov.cn"
        >豫ICP备2022018204号-10</a
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      urlName: "",
    };
  },
  created() {
    this.getUrl();
  },
  methods: {
    getUrl() {
      var curWwwPath = window.document.location.href;
      console.log("当前网址：", curWwwPath);
      if (curWwwPath == "http://huiyida99.com/") {
        this.urlName = "2022018204号-2";
      }
      if (curWwwPath == "http://shuziyuqing.com/") {
        this.urlName = "2022018204号-3";
      }
      if (curWwwPath == "http://shuziyuqing.cn/") {
        this.urlName = "2022018204号-4";
      }
      if (curWwwPath == "http://huiyida99.cn/") {
        this.urlName = "2022018204号-5";
      }
    },
  },
};
</script>
<style>
.indexPage {
  position: relative;
  width: 100%;
  height: 960px;
  background: url(../../assets/images/indexPage/indexPagePg.png) no-repeat;
  background-position: center;
  background-size: cover;
}
.bigRound {
  position: absolute;
  width: 100%;
  height: 960px;
  background: url(../../assets/images/indexPage/bigRound.png) no-repeat;
  background-position: center;
  background-size: cover;
}
.miniRound {
  position: absolute;
  width: 100%;
  height: 960px;
  background: url(../../assets/images/indexPage/miniRound.png) no-repeat;
  background-position: center;
  background-size: cover;
}
.btnBg {
  position: absolute;
  width: 66%;
  height: 960px;
  margin-left: 326px;
  background: url(../../assets/123.png) no-repeat;
  background-position: center;
  background-size: cover;
}
.centerRoundBig {
  position: absolute;
  top: 302px;
  left: 760px;
  width: 400px;
  height: 400px;
  animation: myfirst2 16s infinite linear;
  /* background:url(../../assets/images/indexPage/centerRoundBig.png) no-repeat; */
}
@keyframes myfirst2 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-359deg);
  }
}

.centerRoundMini {
  position: absolute;
  top: 352px;
  left: 810px;
  width: 300px;
  height: 300px;
  animation: myfirst 16s infinite linear;
  /* background:url(../../assets/images/indexPage/centerRoundMini.png) no-repeat; */
}
@keyframes myfirst {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.arrow {
  position: absolute;
  top: 400px;
  width: 100%;
  height: 225px;
  background: url(../../assets/images/indexPage/arrow.png) no-repeat;
  background-position: center;
  background-size: cover;
}
.btn1 {
  position: absolute;
  top: 400px;
  left: 380px;
  cursor: pointer;
}
.btn2 {
  position: absolute;
  top: 400px;
  right: 380px;
  cursor: pointer;
}
.btn3 {
  position: absolute;
  top: 500px;
  left: 380px;
  cursor: pointer;
}
.btn4 {
  position: absolute;
  top: 500px;
  right: 380px;
  cursor: pointer;
}
.btn5 {
  position: absolute;
  top: 600px;
  right: 380px;
  cursor: pointer;
}
.btn6 {
  position: absolute;
  top: 600px;
  left: 380px;
  cursor: pointer;
}
.centerTit {
  position: absolute;
  top: 460px;
  left: 860px;
  width: 200px;
}
.tit-item {
  width: 100%;
  text-align: center;
  font-size: 34px;
  font-weight: 600;
}
.font-size-28 {
  font-size: 28px;
}
.font-weight-700 {
  font-weight: 500;
}
/* 正传旋转 */
.a {
  transition: all 2s;
}
.g {
  transform: rotate(-360deg);
  transition: all 2s;
}
.fg {
  transform: rotate(360deg);
  transition: all 2s;
}

.beian {
  position: fixed;
  text-align: center;
  bottom: 10px;
  width: 100%;
  height: 60px;
  font-size: 36px;
}
a {
  text-decoration: none;
}
</style>